import type { Flags } from '@widget/core';

export type AdditionalQueryParams = {
  widgetId?: string;
  market?: string;
  flags?: Flags;
  agent?: string;
  widgetName?: 'WidgetX' | 'SalesAppointments';
};

export type WidgetMetaData = {
  widgetId: string | 'default';
  widgetName: 'WidgetX' | 'SalesAppointments';
  userTimestamp: string | null;
  flags: Flags;
  agent?: string;
  referrer: string;
};

export enum UtmParamNames {
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  utm_content = 'utm_content',
  tp_channel = 'tp_channel',
  msclkid = 'msclkid',
}

export type UtmParams = {
  [k in UtmParamNames]?: string;
};

export const APPOINTMENT_TYPE = {
  ON_SITE: 'OnSite',
  CALL: 'Call',
} as const;

export type AppointmentType = (typeof APPOINTMENT_TYPE)[keyof typeof APPOINTMENT_TYPE];

export const SALES_APPOINTMENT_TYPE = 'Sales';

export type TimeSlotType = {
  email: string;
  isOptimal: boolean;
  isoDateTime: string;
};

export type TimeSlotsObjectType = {
  timeslots: Record<string, { slots: TimeSlotType[] }>;
  total: number;
  totalOptimalSlots: number;
};

export type TimeSlotsType = Record<AppointmentType, TimeSlotsObjectType | null>;

export type BookedSlotType = {
  startTime: string;
  type: AppointmentType;
};

export type BookedSlot = BookedSlotType & {
  isNewAppointment: boolean;
  startTime: string;
};

export type LeadDataResponse = {
  id: string;
  customerToken?: string;
  oldCustomerToken?: string;
  salesforceId?: string;
  customerDataServiceId?: string;
  customerContact?: {
    phone: string;
  };
  isNewCustomer?: boolean;
  eventId?: string;
  bookedSlot?: BookedSlot;
};

export type ApiResponse<Data = unknown, Error = unknown> =
  | {
      error: false;
      data: Data;
    }
  | {
      error: true;
      // some of the resp still have data, not errorData, need gradually change to errorData
      data?: Error;
      errorData?: Error;
    };

export type RedirectItem = {
  from: string;
  control: string;
  test: string;
  percentage: string;
};

export type NavItem = {
  name: string;
  link: { url: string };
  children?: NavItem[];
};
